/**
  Snippet: boton-compra-fijo
  Sticky stacked add-to-cart bar para producto 
  Solo se muestra si el producto tiene stock (product.available)
**/

(function() {
  function initStickyATC() {
    var sticky = document.querySelector('[data-boton-compra-fijo]');
    var mainButton = document.querySelector('[data-add-to-cart]');
    if (!sticky || !mainButton) return;

    var stickyButton = sticky.querySelector('[data-boton-compra-fijo-button]');
    var stickyPrice = sticky.querySelector('[data-boton-compra-fijo-price]');
    var mainPrice = document.querySelector('[data-product-price]');
    var footer = document.querySelector('footer');

    /* --- Idioma activo para el texto del botón --- */
    var lang = (document.documentElement.lang || 'es').slice(0, 2); // 'es-ES' -> 'es'
    var translations = {
      es: 'Añadir a la cesta',
      en: 'Add to cart',
      it: 'Aggiungi al carrello'
    };

    if (stickyButton && translations[lang]) {
      stickyButton.textContent = translations[lang];
    }

    /* --- JSON del producto para saber disponibilidad de variantes --- */
    var productJsonScript = document.querySelector('script[data-product-json]');
    var productData = null;
    var variantsById = {};

    if (productJsonScript) {
      try {
        productData = JSON.parse(productJsonScript.textContent || productJsonScript.innerHTML);
        if (productData && productData.variants) {
          productData.variants.forEach(function(v) {
            variantsById[String(v.id)] = v;
          });
        }
      } catch (e) {
        console.warn('boton-compra-fijo: error parsing product JSON', e);
      }
    }

    /* --- Localizar el input de variante de forma robusta (multi-idioma) --- */
    var variantInput = null;
    var parentForm = mainButton.closest('form');

    if (parentForm) {
      variantInput = parentForm.querySelector('input[name="id"]');
    }

    if (!variantInput) {
      // Fallback genérico por si el tema cambia algo
      variantInput = document.querySelector('form input[name="id"]');
    }

    /* --- Estado global de la barra --- */
    var state = {
      atcVisible: true,
      footerVisible: false,
      variantAvailable: true
    };

    function updateVariantAvailability() {
      if (!variantInput || !Object.keys(variantsById).length) {
        // Si no tenemos datos, no bloqueamos la barra
        state.variantAvailable = true;
        updateBar();
        return;
      }

      var id = String(variantInput.value || '');
      var variant = variantsById[id];

      // Solo visible si la variante existe y tiene available = true
      state.variantAvailable = !!(variant && variant.available);
      updateBar();
    }

    function updateBar() {
      // Mostrar sólo si:
      // - el botón principal NO está visible
      // - el footer NO está visible
      // - la variante seleccionada está disponible
      if (!state.atcVisible && !state.footerVisible && state.variantAvailable) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }

    /* --- Click del sticky = click en el botón principal --- */
    if (stickyButton && mainButton) {
      stickyButton.addEventListener('click', function(e) {
        e.preventDefault();
        mainButton.click();
      });
    }

    /* --- Sincronizar el precio sticky con el precio principal --- */
    if (stickyPrice && mainPrice && 'MutationObserver' in window) {
      var observer = new MutationObserver(function() {
        stickyPrice.innerHTML = mainPrice.innerHTML;
      });
      observer.observe(mainPrice, {
        childList: true,
        subtree: true,
        characterData: true
      });
      // Primera sincronización
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    /* --- Observers: botón principal y footer --- */
    if ('IntersectionObserver' in window) {
      var atcObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          state.atcVisible = entry.isIntersecting;
          updateBar();
        });
      }, { threshold: 0.1 });

      atcObserver.observe(mainButton);

      if (footer) {
        var footerObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            state.footerVisible = entry.isIntersecting;
            updateBar();
          });
        }, { threshold: 0.01 });

        footerObserver.observe(footer);
      }
    } else {
      // Fallback sin IntersectionObserver (por si acaso)
      function onScroll() {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var rect = mainButton.getBoundingClientRect();
        var atcInView = rect.top >= 0 && rect.bottom <= vh;

        var footerInView = false;
        if (footer) {
          var fRect = footer.getBoundingClientRect();
          footerInView = fRect.top < vh && fRect.bottom > 0;
        }

        state.atcVisible = atcInView;
        state.footerVisible = footerInView;
        updateBar();
      }

      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    /* --- Escuchar cambios de variante (tema usa AJAX, no recarga) --- */
    if (variantInput) {
      variantInput.addEventListener('change', updateVariantAvailability);
      variantInput.addEventListener('input', updateVariantAvailability);
      // Primer cálculo
      updateVariantAvailability();
    } else {
      updateBar();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();